/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Decimal from 'decimal.js';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
// import { get } from 'session';
import { MAX_LIMIT } from 'modules/common/constants';
import { ucwords } from '../../../helper';
import * as actions from '../../../actions';
import * as c from '../../../constant';

function CreateRangeModal({
  formData,
  getBusinessLinesList,
  businessLinesList,
  getNecessaryFieldsList,
  necessaryFieldsList,
  setFormData,
  closeModal,
  handleOnCreate,
  detailFormData,
  setDetailFormData,
  formDataQuantityMatrix,
  setFormDataQuantityMatrix,
}) {
  const filteredNecessaryFieldsList = necessaryFieldsList.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = necessaryFieldsList.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  // const quantityMatrix = filteredQuantityMatrix?.quantity_matrix || [];

  const validateForm = useFormValidator(formData, {
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
    industrial_code: 'required',
  });

  useEffect(() => {
    getBusinessLinesList();
    setFormData({
      business_line_id: '',
      capital_amount: '',
      gross_amount: '',
      industrial_code: '',
    });
  }, []);

  const handleLineDropDownChange = (key) => (e) => {
    setDetailFormData({});
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      industrial_code: e.industrial_code,
    });

    getNecessaryFieldsList({
      business_line_id: e.value,
      application_status_id: 21 || 0,
    });
  };

  const selectBusinessLineId = businessLinesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
    industrial_code: _.get(x, 'attributes.code'),
  }));

  const handleOfficeTypeDropDownChange = (key) => (e) => {
    setDetailFormData({
      ...detailFormData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = (list) => {
    const newList = [];

    list.map((data) => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = (e) => {
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleOnChangeDetail = (e) => {
    const { name, value } = e;
    setDetailFormData({
      ...detailFormData,
      [name]: value,
    });
  };

  const onChangeQuantityMatrix = (key, value) => {
    setFormDataQuantityMatrix({
      ...formDataQuantityMatrix,
      [key]: value,
    });
  };

  const onBlurDecimal = (e) => {
    setFormData({
      ...formData,
      [_.get(e, 'target.name')]: parseFloat(_.get(e, 'target.value')),
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <div>
      <div className="row">
        <div className="col-6 form-group">
          <label className="form-label">
            Business Line:
            {validateForm.renderMessage('business_line_id')}
          </label>
          <Select
            options={selectBusinessLineId}
            placeholder="Select Business Line"
            onChange={handleLineDropDownChange('business_line_id')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Philippine Standard Industrial Code:{' '}
            {validateForm.renderMessage('industrial_code')}
          </label>
          <input
            className="form-control"
            type="text"
            name="industrial_code"
            onChange={(e) => {
              const { name, value } = e.target;
              const props = {
                name,
                value,
              };
              handleOnChange(props);
            }}
            value={_.get(formData, 'industrial_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">
            Capital Amount:
            {validateForm.renderMessage('capital_amount')}
          </label>
          <NumberFormat
            name="capital_amount"
            id="capital_amount"
            placeholder="0.00"
            className="form-control"
            onValueChange={(values) => {
              const { value } = values;
              const props = {
                name: 'capital_amount',
                value,
              };
              handleOnChange(props);
            }}
            displayType="input"
            decimalScale={2}
            isNumericString
            allowNegative
            thousandSeparator
            allowLeadingZeros
            prefix="₱ "
            value={_.get(formData, 'capital_amount')}
            isAllowed={(values) => {
              const { value } = values;
              if (!value) return true;
              const val = new Decimal(value);
              const max = new Decimal(MAX_LIMIT);
              return value === undefined || val.lte(max);
            }}
          />
        </div>

        {filteredNecessaryFieldsList.map((item) => {
          const itemOptions = _.get(item, 'options');
          const itemMultiplier = _.get(item, 'multiplier');
          const label = ucwords(_.get(item, 'multiplier').replace(/_/g, ' '));
          const hasGrossKey = itemMultiplier.includes('gross_amount_');

          if (itemOptions) {
            return (
              <div className="col-6 form-group" key={itemMultiplier}>
                <label className="form-label">{label}</label>
                <Select
                  onChange={handleOfficeTypeDropDownChange(itemMultiplier)}
                  options={selectOptions(itemOptions)}
                />
              </div>
            );
          }

          return (
            <div className="col-6 form-group" key={itemMultiplier}>
              <label className="form-label">{label}</label>
              <NumberFormat
                name={itemMultiplier}
                id={itemMultiplier}
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const props = {
                    name: itemMultiplier,
                    value,
                  };
                  handleOnChangeDetail(props);
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                prefix={hasGrossKey ? '₱ ' : ''}
                value={_.get(detailFormData, itemMultiplier)}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!hasGrossKey || !value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
          );
        })}

        {!_.isEmpty(filteredQuantityMatrix) ? (
          filteredQuantityMatrix.map((item) => {
            const multiplier = _.get(item, 'multiplier', '');

            return (
              <React.Fragment>
                <div className='form-group col-12 mb-0'>
                  <label className='form-label mb-0 text-capitalize'>
                    {multiplier}
                  </label>
                </div>
                <div className="w-100 border rounded-lg mx-3">
                  <table className="table table-borderless table-sm table-striped table-hover mb-0">
                    <thead>
                      <tr className="form-group">
                        <td className="col-4 form-label text-center border-right">Unit</td>
                        <td className="col-4 form-label text-center border-right">Capacity</td>
                        <td className="col-4 form-label text-center">Number of Units</td>
                      </tr>
                    </thead>
                    <tbody>
                      {item.quantity_matrix.map((quantityMatrixItem) => {
                        const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                        return (
                          <tr key={quantityMatrixMultiplier} className="border-top form-group">
                            <td className="col-4 text-left form-label border-right">
                              {_.get(quantityMatrixItem, 'unit')}
                            </td>
                            <td className="col-4 text-left form-label border-right">
                              {_.get(quantityMatrixItem, 'capacity')}
                            </td>
                            <td className="col-4 text-left form-label">
                              <NumberFormat
                                name={quantityMatrixMultiplier}
                                id={quantityMatrixMultiplier}
                                className="form-control"
                                onValueChange={(values) => {
                                  const { floatValue } = values;
                                  onChangeQuantityMatrix(quantityMatrixMultiplier, floatValue);
                                }}
                                displayType="input"
                                thousandSeparator
                                allowLeadingZeros
                                isNumericString
                                value={_.get(formDataQuantityMatrix, `${quantityMatrixMultiplier}`, '')}
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </React.Fragment>
            )
          })
        ) : (
          ''
        )}
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          onClick={handleOnCreate(formData)}
        >
          <span className="font-weight-bold">Add</span>
        </button>
        <button
          type="button"
          onClick={() => closeModal()}
          className="mt-3 btn btn-dark"
        >
          <span className="font-weight-bold">Cancel</span>
        </button>
      </div>
      <hr />
    </div>
  );
}

CreateRangeModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  closeModal: PropTypes.instanceOf(Function).isRequired,
  handleOnCreate: PropTypes.instanceOf(Function).isRequired,
  detailFormData: PropTypes.instanceOf(Object).isRequired,
  setDetailFormData: PropTypes.instanceOf(Function).isRequired,
  formDataQuantityMatrix: PropTypes.instanceOf(Object).isRequired,
  setFormDataQuantityMatrix: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateRangeModal);
